// extracted by mini-css-extract-plugin
module.exports = {"flagsWrapper":"style__flagsWrapper__J3oNh"};